import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CoreApiService } from '../../core/service/core-api-service';
import { properties } from '../../../environments/properties';
import { JsonResponse } from '../../model/jsonResponse.model';
import { Router } from '@angular/router';
import { AppService } from '../../core/service/app.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    InputTextModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CardModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent {
  loginResponse!: JsonResponse;
  codeOK = properties.codeOK;
  codeERROR = properties.codeERROR;

  formLogin = new FormGroup({
    user: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  constructor(
    private readonly apiService: CoreApiService,
    private readonly router: Router,
    private readonly appService: AppService,
  ) {}

  login() {
    const dataLogin = {
      data: {
        user: this.formLogin.get('user')?.value,
        password: this.formLogin.get('password')?.value,
      },
      empresa: 1,
    };

    this.apiService.consumirWSPost(
      properties.serviceLogin,
      dataLogin,
      (data) => {
        this.loginResponse = data;
        if (this.loginResponse.estado == this.codeOK) {
          this.appService.login(data);

          const menus = this.loginResponse.data.menus || [];
          const firstMenu = menus.find((m: any) => m.menu_active);
          if (firstMenu) {
            this.router.navigate([firstMenu.menu_route]);
          } else {
            this.router.navigate(['/no-access']);
          }
        } else {
          this.appService.mostrarToast('Login', 'Error de credenciales', 4);
        }
      },
    );
  }
}
